<template>
    <div>

        <div class="vx-breadcrumb ml-4 pl-4 mb-6 md:block hidden">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end" style="padding-top: 3px;">
                    <router-link :to="'/'">
                        <span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg"
                                                                             width="24px" height="24px"
                                                                             viewBox="0 0 24 24" fill="none"
                                                                             stroke="currentColor" stroke-width="2"
                                                                             stroke-linecap="round"
                                                                             stroke-linejoin="round"
                                                                             class="feather feather-home h-5 w-5 mb-1 stroke-current text-primary"><path
                            d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline
                            points="9 22 9 12 15 12 15 22"></polyline></svg></span>
                    </router-link>
                    <span class="breadcrumb-separator mx-2">
                        <span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg"
                                                                             width="24px" height="24px"
                                                                             viewBox="0 0 24 24" fill="none"
                                                                             stroke="currentColor" stroke-width="2"
                                                                             stroke-linecap="round"
                                                                             stroke-linejoin="round"
                                                                             class="feather feather-chevrons-right w-4 h-4"><polyline
                            points="13 17 18 12 13 7"></polyline><polyline
                            points="6 17 11 12 6 7"></polyline></svg></span>
                    </span>
                </li>
                <li v-for="bc in this.breadcrumbs" :class="bc.active ? 'inline-flex' : 'inline-flex items-center'">
                    <span v-if="!bc.url" class="cursor-default" @click="getProduct()">{{ $t(bc.title) }}</span>
                    <router-link v-else :to="bc.url">
                        {{ $t(bc.title) }}
                    </router-link>
                    <span v-if="!bc.active" class="breadcrumb-separator mx-2 flex items-start">
                        <span class="feather-icon select-none relative"><svg xmlns="http://www.w3.org/2000/svg"
                                                                             width="24px" height="24px"
                                                                             viewBox="0 0 24 24" fill="none"
                                                                             stroke="currentColor" stroke-width="2"
                                                                             stroke-linecap="round"
                                                                             stroke-linejoin="round"
                                                                             class="feather feather-chevrons-right w-4 h-4"><polyline
                            points="13 17 18 12 13 7"></polyline><polyline
                            points="6 17 11 12 6 7"></polyline></svg></span>
                    </span>
                </li>
            </ul>
        </div>

        <div class="container">
            <div class="col-lg-8">
                <vx-card
                    v-if="product.Amount || product.cash"
                    :product_top="true"
                    :image="product.image"
                    :gallery2="product.image"
                    :title="product.FullTitle"
                    :product="product"
                    :allSegmentProducts="allSegmentProducts"
                    title-color="primary"
                    class="mb-5"
                    @customers="customers = $event"
                    @customer_id="customer_id = $event"
                    :description="product.Description">
                </vx-card>
                <vx-card
                    title=""
                    title-color=""
                    class="mb-5"
                    subtitle="">

                    <div class="vx-row">
                        <div class="vx-col sm:w-4/12 w-full pt-3" v-for="(key, value) in product.options" v-if="key" style="justify-content: center;align-items: center;">
                            <table>
                                <tr>
                                    <td width="1" valign="top"><i class="vs-icon notranslate icon-scale feather icon-check null"></i></td>
                                    <td width="5"></td>
                                    <td>
                                        <b>{{ $t(value) }}</b>
                                        <br>
                                        <span>{{ key }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </vx-card>

                <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top vx-card">

                    <template v-if="product.provider_id === 3">
                        <template v-if="customer_id != 0">
                            <div class="con-ul-tabs">
                                <ul class="ul-tabs vs-tabs--ul">
                                    <li v-for="(post, key, index) in getTabsForAdobe" :key="index" class="vs-tabs--li"
                                        :class="{activeChild:index === 0}" :id="'nav_'+key" @click="showContent(key)"
                                    >
                                        <button type="button" class="vs-tabs--btn" v-if="post !== ''">
                                            <span>{{ $t(key) }}</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div class="con-slot-tabs">
                                <div class="con-tab vs-tabs--content">
                                    <div class="vx-row flex content_all" v-for="(post, key, index) in getTabsForAdobe"
                                         :class="{active:index === 0}" :key="key" :id="'content_'+key">
                                        <span class="ml-5" v-html="post"></span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="con-ul-tabs">
                            <ul class="ul-tabs vs-tabs--ul">
                                <li v-for="(post, key, index) in product.tabs" :key="index" class="vs-tabs--li"
                                    :class="{activeChild:index === 0}" :id="'nav_'+key" @click="showContent(key)"
                                >
                                    <button type="button" class="vs-tabs--btn" v-if="post !== ''">
                                        <span>{{ $t(key) }}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="con-slot-tabs">
                            <div class="con-tab vs-tabs--content">
                                <div class="vx-row flex content_all" v-for="(post, key, index) in product.tabs"
                                     :class="{active:index === 0}" :key="key" :id="'content_'+key">
                                    <span class="ml-5" v-html="post"></span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        breadcrumbs: [],
        product: [],
        customers: [],
        customer_id: 0,
        allSegmentProducts: [],
        userInfo: window.userInfo,
      }
    },
    watch: {
      '$route'(to, from) {
        if (from.params.id !== to.params.id) {

          const thisIns = this;

          let url = apiUrl + '/product/' + this.$route.params.id+'/show?token=' + token;
          if (this.userInfo.need_azn_cash) url = apiUrl + '/product/azn/' + this.$route.params.id+'?token=' + token;

          axios.get(url)
            .then(function (response) {

              let data = response.data;
              if (data.code === 200) {
                thisIns.breadcrumbs = data.data.breadcrumbs;
                thisIns.product = data.data.product;
                thisIns.allSegmentProducts = data.data.segments;
              } else {
                if (data.code === 401) {
                  window.logout();
                }
                thisIns.$vs.notify({
                  title: 'Error',
                  text: data.message,
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                });
              }

            });

        }
      }
    },
    created() {
      const thisIns = this;

      let url = apiUrl + '/product/' + this.$route.params.id+'/show?token=' + token;
      if (this.userInfo.need_azn_cash) url = apiUrl + '/product/azn/' + this.$route.params.id+'?token=' + token;

      axios.get(url)
        .then(function (response) {

          let data = response.data;
          if (data.code === 200) {
            thisIns.breadcrumbs = data.data.breadcrumbs;
            thisIns.product = data.data.product;
            thisIns.allSegmentProducts = data.data.segments;
          } else {
            if (data.code === 401) {
              window.logout();
            }
            thisIns.$vs.notify({
              title: 'Error',
              text: data.message,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            });
          }

        });
    },
    computed: {},
    methods: {
        getTabsForAdobe(){
            if (this.customer_id == 0) return [];
            if (this.allSegmentProducts.length == 0) return [];

            return this.allSegmentProducts[this.customers.find((customer) => { return customer.id == customer_id }).customer.companyProfile.marketSegment].tabs;
        },
      showContent(ids) {
        let content_all = document.getElementsByClassName('content_all');
        for (let i = 0; i < content_all.length; i++) {
          content_all[i].classList.remove("active");
        }
        document.getElementById('content_' + ids).classList.add("active");

        let vsTab = document.getElementsByClassName('vs-tabs--li');
        for (let i = 0; i < vsTab.length; i++) {
          vsTab[i].classList.remove("activeChild");
        }
        document.getElementById('nav_' + ids).classList.add("activeChild");

      },
      getProduct() {
        /*console.log('fafafa');
        console.log(this.product);*/
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>

    .con-ul-tabs{
        z-index: 2;
        .vs-tabs--li{
            background: #4d71b5;
            color: #fff;
            border-right: 2px solid #f8f8f8;

            &:hover{
                background: #ffffff;
            }

            &.activeChild{
                background: #ffffff;
                border-bottom: 2px solid #ffffff;
                button{
                    padding: 10px;
                }
            }
        }
    }

    .con-slot-tabs{
        border-top: 2px solid #4d71b5;
        margin-top: -2px;

        .vs-tabs--content{
            background: #ffffff;
        }
    }





    .content_all{
        display: none !important;
    }

    .content_all.active{
        display: flex !important;
    }

    .news-content__inside {
        width: 75%;
        margin: auto;

        &__title {
            padding: 15px;
            padding-left: 0;
            color: #000;
            border-radius: 0;
            font-size: 30px;
        }

        &__subtitle {
            margin: 20px 0 15px 0;
        }

        &__text {
            padding: 30px;
            background: #fff;
            border-radius: 8px;
            -webkit-box-shadow: 0 2px 50px 0 rgba(0, 0, 0, .05);
            box-shadow: 0 2px 50px 0 rgba(0, 0, 0, .05);
            margin-bottom: 30px;
            overflow: hidden;
            margin-top: 0;
        }
    }
</style>
